import { useCallback, useEffect, useState } from "react";

import { API_BASE_URL } from "@/api/api.config";
import fetchJson from "@/remoteState/fetchJson";

const useGetUserLicenses = () => {
  const [licenses, setLicenses] = useState([]);

  const getLicenses = useCallback(async () => {
    try {
      const userLicenses = await fetchJson(
        `${API_BASE_URL}/api/v2/user/me/license/`,
      );

      if (userLicenses) {
        setLicenses(userLicenses);
      }
    } catch (err) {
      console.error(err);
    }
  }, []);

  useEffect(() => {
    getLicenses();
  }, [getLicenses]);

  return licenses;
};

export default useGetUserLicenses;
